import React from 'react';
import { connect } from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import { saveToHistory , setCurrentStep ,pushToHistory ,initialState} from './BusinessWorkOrderSystemSlice';
import { BusinessWorkOrderSystemStep } from './Constant/Constant';

const BtnNextStep = ({ onClick, text, disabled = false, className = '',saveToHistory,error , errorText, setCurrentStep ,nextStep,businessWorkOrderSystem ,pushToHistory }) => {

    async function handleNextStep() {
        var currentStep = businessWorkOrderSystem.currentStep;     
        if(onClick){
          nextStep = await onClick();
        }
         if(nextStep){
            if(currentStep===BusinessWorkOrderSystemStep.Dashboard){
              pushToHistory(currentStep);
            }
            saveToHistory(currentStep);
            setCurrentStep(nextStep);
         }
         return;
    }

  return (
    <div className={`continue-button ${className}`}>
     {error && <div className='error center'>{errorText}</div>}
      <BtnSubmit 
        onclick={handleNextStep} 
        text={text || 'המשך'} 
        disabled={disabled}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});

const mapDispatchToProps = {
  saveToHistory,
  setCurrentStep,
  pushToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(BtnNextStep);
